import React, { useState } from 'react';
import './Blog.css';
import { Modal, Button } from 'react-bootstrap';
import articleImage from '../img/img-20.jpg';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Blog: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModal2, setShowModal2] = useState<boolean>(false);
  const [showModal3, setShowModal3] = useState<boolean>(false);
  const [showModal4, setShowModal4] = useState<boolean>(false);
  const [showModal5, setShowModal5] = useState<boolean>(false);


  const handleArticleClick = (): void => {
    setShowModal(true);
  };

  const handleModalClose = (): void => {
    setShowModal(false);
  };

  const handleArticle2Click = (): void => {
    setShowModal2(true);
  };

  const handleModal2Close = (): void => {
    setShowModal2(false);
  };

  const handleArticle3Click = (): void => {
    setShowModal3(true);
  };

  const handleModal3Close = (): void => {
    setShowModal3(false);
  };


  const handleArticle4Click = (): void => {
    setShowModal4(true);
  };

  const handleModal4Close = (): void => {
    setShowModal4(false);
  };

  
  const handleArticle5Click = (): void => {
    setShowModal5(true);
  };

  const handleModal5Close = (): void => {
    setShowModal5(false);
  };


  return (
    <div className="body">
      <Header onSearchClick={() => console.log("Search button clicked")} />

      <div className="parent-container64">
        <div className="container64">
          <h1>Discover Inspiring Stories and Advice</h1>
          <p>
            Explore a collection of articles covering relationships, marriage
            tips, and success stories in the world of the 'MarryUp'.
          </p>
        </div>
      </div>

      {/* Article Preview Section */}
      <div className="article-preview-container">
        <div className="article-preview" onClick={handleArticleClick}>
          <img
            src={articleImage}
            alt="Article Preview"
            className="article-image"
          />
          <h3>
            11 Old-Fashioned Relationship Habits We Should Start Bringing Back
          </h3>
          <p>
            Learn to love the way it's taught in the book "Men are from Mars
            and Women are from Venus" by John Gray. This is to protect the
            marriage and prevent major issues...
          </p>
        </div>

        <div className="article-preview" onClick={handleArticle2Click}>
          <img src={articleImage} alt="Article Preview" className="article-image" />
          <h3>More Than Matches: Why We’re Building a Space for Real Connections</h3>
          <p>
            At nrimarriage.in, we’re building more than just a platform — we’re shaping a space where people from around the world can connect with sincerity and curiosity...
          </p>
        </div>

        <div className="article-preview" onClick={handleArticle3Click}>
          <img src={articleImage} alt="Article Preview" className="article-image" />
          <h3>Why High-Standard Dating is the Future — And How MarryUp is Leading the Way</h3>
          <p>
            Looking for a serious connection without compromising your standards? Discover why high-standard dating apps like MarryUp are changing the game for ambitious singles...
          </p>
        </div>

        <div className="article-preview" onClick={handleArticle4Click}>
          <img src={articleImage} alt="Article Preview" className="article-image" />
          <h3>4 Mindset Shifts That Attract Higher-Quality Matches Instantly</h3>
          <p>
            Struggling to meet people who meet your standards? It might be your mindset — not your luck. These 4 shifts change the game...
          </p>
        </div>

        <div className="article-preview" onClick={handleArticle5Click}>
          <img src={articleImage} alt="Article Preview" className="article-image" />
          <h3>5 Dating App Green Flags You Shouldn’t Ignore — Especially on MarryUp</h3>
          <p>
            Forget red flags. These signs show you're using a dating app that actually works — and why MarryUp checks all the right boxes...
          </p>
        </div>


      </div>


      {/* Styled Modal for Article Details */}
      <Modal show={showModal} onHide={handleModalClose} centered dialogClassName='custom-modal'>
        <Modal.Header closeButton className='modal-header-custom'>
          <Modal.Title className='modal-title-custom'>11 Old-Fashioned Relationship Habits</Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body-custom'>
          <img src={articleImage} alt='Article' className='modal-image' />
          <div className='article-content'>
            {/* Full Article Content */}
            <p>Learn to love the way it's taught in the book " Men are from Mars and women from Venus" by John Gray. This is to protect the marriage and also to prevent major issues. Remember, prevention is better than cure.<br />
              Little acts of kindness done daily is the 'love portion' for thriving relationships and keeping the spark alive for decades.
            </p>
            <h4>1. Time Together: Quality over Quantity</h4>
            <p>
              <b>So no phones, technology or to do lists while spending quality time together!</b><br />
              In today's fast-paced world, it\'s easy to get caught up in the hustle and bustle of daily life. However, quality time with your partner is essential for a healthy relationship. Set aside device-free, distraction-free time together, focusing on shared experiences and connections. This can be as simple as going for a walk, cooking dinner together, or engaging in a hobby. By prioritizing quality time, you strengthen your bond, foster deeper conversations, and create lasting memories. Regularly schedule this time into your daily or weekly routine, ensuring that your relationship remains a priority.

            </p>

            <h4>2. Be Curious: Ask Questions and Show Interest</h4>
            <p>
              <b>Ask questions to know more and be genuinely interested in the moment of the conversation.</b><br />
              Maintaining curiosity and interest in your partner's life is vital for a fulfilling relationship. Ask open-ended questions that encourage meaningful conversations, and actively listen to their responses. Show genuine interest in their thoughts, feelings, and experiences. This helps prevent complacency and keeps the spark of discovery alive. Explore new experiences together, whether trying a new restaurant, taking a weekend trip, or learning a new skill. By staying curious, you continue to learn and grow together.

            </p>

            <h4>3. Express Gratitude Daily</h4>
            <p>
              <b>Be grateful for having this person in your life. If not for this person, life could be a lot worse off! </b><br />
              Gratitude is a powerful tool for nurturing a positive relationship. Take time each day to express appreciation for your partner, acknowledging the positive impact they have on your life. Share specific reasons you're thankful for them, whether it\'s their sense of humor, support, or kindness. This cultivates a culture of gratitude and affection, helping to create a warm and loving environment. Verbalize your gratitude through words, actions, or small gestures, ensuring your partner feels valued and cherished.

            </p>

            <h4>4. Work as a Team: Collaborate and Grow</h4>
            <p>
              <b>Working together and help each other grow in every possible aspect is essential to keep the boredom away and keeping the Dopamine dripping in your love relationship.</b><br />
              A healthy relationship is built on teamwork and collaboration. Work together to support each other's goals, aspirations, and personal growth. Celebrate successes and learn from setbacks together, fostering a sense of unity and progress. Recognize that your partner\'s achievements are your achievements, and vice versa. By collaborating, you create a strong foundation for navigating life's challenges and overcoming obstacles.
            </p>

            <h4>5. Inner Beauty Followed by Outer Presentation</h4>
            <p>
              <b>Work on optimizing inner beauty and pay due attention to external appearance too.</b><br />
              Perhaps, you fell in love based on appearance at first and the love grew wings with the personality traits later.
              While physical attraction is important, inner beauty is the foundation of a lasting relationship. Nurture your inner qualities, such as empathy, kindness, and humor, while also taking care of your physical appearance. Recognize that attraction is multifaceted, and both aspects contribute to a fulfilling relationship. Invest time in self-care, personal growth, and self-improvement, ensuring you're the best version of yourself for your partner.
            </p>

            <h4>6. Honest Communication: Tell the Truth</h4>
            <p>
              <b>Tell the truth but be sensible to the timing and location. Lies are unnecessary. If truth cannot be told, a smile or silence would be safer than a lie. Remember, lies follow a chain of more lies, all unnecessary hassle!</b><br />
              Honesty is essential for building trust and maintaining a healthy relationship. Practice transparency, sharing thoughts and feelings in a considerate and timely manner. Avoid lies, which can lead to unnecessary complications and erode trust. Be mindful of the timing and location of sensitive conversations, ensuring your partner feels comfortable and receptive. Remember, honesty builds trust, while dishonesty can damage your relationship irreparably.
            </p>

            <h4>7. Just Say Sorry: Conflict Resolution</h4>
            <p>
              <b>Don't you worry, it will not reduce your bank balance, if anything,  it might increase it!</b><br />
              It's better to lose the argument and win the person than win the argument and lose your love relationship.
              No relationship is immune to conflicts, but it's how you resolve them that matters. Prioritize relationship harmony over winning arguments. Apologize when necessary, demonstrating empathy and a willingness to grow together. Recognize that apologizing doesn't diminish your self-worth; rather, it shows strength and a commitment to your partner's feelings. By resolving conflicts in a constructive manner, you strengthen your bond and foster a culture of understanding.
            </p>

            <h4>8. Open Communication of Issues</h4>
            <p>
              <b>Speak out your relationship issues openly in private, and of course, first express how much you love this person and desire the preferred changes to spice up your love relationship. It's not easy, time consuming,  sometimes,  several years. But, it works!</b><br />
              Addressing relationship concerns in a constructive manner is crucial for maintaining a healthy partnership. Discuss issues privately, starting with affirmations of love and appreciation. Engage in open and honest conversations, actively listening to each other's perspectives. Approach these discussions with empathy and understanding, seeking solutions rather than placing blame. By addressing issues openly, you prevent resentment and foster a stronger connection.
            </p>

            <h4>9. Optimism and Daily Encouragement</h4>
            <p>
              <b>Life may look awful sometimes and awesome occasionally. It should be like, "we may have our ups and downs, but I will always love you!" This is the foundation for thriving marriages. Serve a word of encouragement with meals daily, if needed several times a day too!</b><br />
              Maintaining a positive outlook is essential for navigating life's challenges together. Offer daily encouragement and support, celebrating your partner\'s successes and helping them through difficulties. Recognize that life's ups and downs are inevitable, but with a positive attitude, you can overcome any obstacle. Foster a culture of optimism, gratitude, and appreciation, ensuring your relationship remains resilient and fulfilling.
            </p>

            <h4>10. Promise: Underpromise and Overdeliver</h4>
            <p>
              <b>Always promise a little lesser and overdo it, making it a pleasant surprise for your spouse. We all like it! But if it's other way around,  it's not gonna be pretty!!</b><br />
              Setting realistic expectations is vital for maintaining trust and satisfaction in your relationship. Promise a little less and deliver a little more, making it a pleasant surprise for your partner. This builds trust, fosters appreciation, and creates delightful surprises. Avoid overpromising and underdelivering, which can lead to disappointment and frustration. By exceeding expectations, you demonstrate your commitment and care for your partner's happiness.
            </p>

            <h4>11. Loyalty: Unwavering Commitment</h4>
            <p>
              <b>This is truly basic, if this cannot be done, perhaps marriage is not the right option. There are other options but none of them would make you happy long-term. Difficult to swallow yet true!</b><br />
              Loyalty is the foundation of a healthy, long-term relationship. Demonstrate unwavering commitment and fidelity, recognizing that loyalty is essential for building trust and security. Prioritize your relationship, ensuring you.
            </p>
            <p className="closing-text">
              <strong>All the best everyone!</strong>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className='modal-footer-custom'>
          <Button variant='primary' onClick={handleModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal2} onHide={handleModal2Close} centered dialogClassName='custom-modal'>
        <Modal.Header closeButton className='modal-header-custom'>
          <Modal.Title className='modal-title-custom'>
            More Than Matches: Why We’re Building a Space for Real Connections
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body-custom'>
          <img src={articleImage} alt='Article' className='modal-image' />
          <div className='article-content'>
            <p>
              In a world where swipes, likes, and instant messages dominate how we meet, it’s easy to forget what we’re really searching for: someone who gets us.
            </p>
            <p>
              At <strong>nrimarriage.in</strong>, we’re building more than just a platform — we’re shaping a space where people from around the world can connect with curiosity, sincerity, and a little hope. Whether you’re a young professional in London, a creative in Delhi, or a traveler in Dubai figuring life out, you’re welcome here. And no, you don’t need to be NRI, Indian, or anything in particular — just human.
            </p>
            <p>
              We’ve noticed something missing in the world of online connection: room for nuance. The kind that doesn’t rush you into commitment, but doesn’t reduce you to an aesthetic either. Our goal is simple: create a platform that helps people meet with intention — whatever that intention might be.
            </p>
            <ul>
              <li>Exploring cultural roots while staying open to the world</li>
              <li>Tired of dating apps that feel more like games than conversations</li>
              <li>Someone who values compatibility but doesn’t want formulas</li>
              <li>Or just curious where a real conversation could lead</li>
            </ul>
            <p>
              We’re still growing — adding features, listening to feedback, and evolving every day. But what keeps us going is the belief that even in a digital world, authenticity matters. Connection matters. And yes, love still matters.
            </p>
            <p>
              So whether you’re here to experiment, to explore, or to find something real, welcome. You belong in a space that’s being built with you in mind.
            </p>
            <p><strong>Let’s redefine what “online matchmaking” can mean — together.</strong></p>
            <p className="closing-text"><strong>Join the journey. Start your story. Sign up now.</strong></p>
          </div>
        </Modal.Body>
        <Modal.Footer className='modal-footer-custom'>
          <Button variant='primary' onClick={handleModal2Close}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal3} onHide={handleModal3Close} centered dialogClassName='custom-modal'>
        <Modal.Header closeButton className='modal-header-custom'>
          <Modal.Title className='modal-title-custom'>
            Why High-Standard Dating is the Future — And How MarryUp is Leading the Way
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body-custom'>
          <img src={articleImage} alt='Article' className='modal-image' />
          <div className='article-content'>
            <p>
              Looking for a serious connection without compromising your standards? Discover why high-standard dating apps like MarryUp are changing the game for ambitious singles.
            </p>
            <hr />
            <p>
              In a world flooded with ghosting, swiping, and surface-level matches, more people are demanding dating platforms that actually deliver.
              That’s where high-standard dating comes in — and where MarryUp leads the way.
            </p>

            <h4>What is High-Standard Dating?</h4>
            <p>
              High-standard dating means being intentional about who you connect with — based on lifestyle, ambition, attraction, and personal values.
              It’s not elitist, it’s selective. And it works.
            </p>

            <h4>Why Singles Are Tired of Basic Dating Apps</h4>
            <p>Most apps optimize for numbers, not quality. But swiping endlessly with no results is draining. Singles today are tired of:</p>
            <ul>
              <li>Low-effort conversations</li>
              <li>Matches that don’t align with their goals</li>
              <li>Algorithms that favor popularity over compatibility</li>
            </ul>

            <h4>How MarryUp Raises the Bar</h4>
            <p>MarryUp is designed for people with taste, ambition, and standards. Here’s what sets it apart:</p>
            <ul>
              <li>Curated profiles</li>
              <li>Manual order acceptance for safety and control</li>
              <li>In-app lifestyle store for extra depth</li>
              <li>Optional AI-enhanced matchmaking</li>
            </ul>

            <h4>Real Results, Real Connections</h4>
            <p>
              Whether you’re a high-achieving woman or a man with strong preferences, MarryUp helps you connect on a level that regular apps don’t reach.
              It’s not just about looks — it’s about lifestyle, values, and vision.
            </p>

            <p className="closing-text">
              <strong>Ready to meet someone who actually matches your worth?</strong><br />
              <a href="/register" className="btn btn-link">Join MarryUp now</a>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className='modal-footer-custom'>
          <Button variant='primary' onClick={handleModal3Close}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={showModal4} onHide={handleModal4Close} centered dialogClassName="custom-modal">
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title className="modal-title-custom">
            4 Mindset Shifts That Attract Higher-Quality Matches Instantly
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <img src={articleImage} alt="Article" className="modal-image" />
          <div className="article-content">
            <p>
              Struggling to meet people who meet your standards? It might not be your looks, location, or luck — it might be your mindset. Here are 4 shifts that instantly change the way high-quality matches see you.
            </p>

            <hr />

            <ol>
              <li>
                <strong>1. From “Am I Good Enough?” to “Are They Right for Me?”</strong><br />
                Instead of performing to impress, you’re evaluating if someone fits into your values and vision. Confidence is magnetic — and it starts with self-worth.
              </li>

              <li>
                <strong>2. From Passive to Intentional</strong><br />
                Swiping endlessly and hoping for magic? High-standard dating means showing up with purpose. Set real intentions, define your dealbreakers, and lead with clarity.
              </li>

              <li>
                <strong>3. From Avoiding Vulnerability to Embracing It</strong><br />
                Walls block connection. The right people aren’t scared off by honesty — they’re drawn in. Vulnerability is strength in high-quality dating.
              </li>

              <li>
                <strong>4. From “Who Likes Me?” to “Who Matches My Energy?”</strong><br />
                You’re not here to chase — you’re here to align. High-quality matches happen when your energy, ambition, and values mirror each other.
              </li>
            </ol>

            <p className="closing-text">
              <strong>MarryUp isn’t just a dating app. It’s a mindset matchmaker.</strong><br />
              <a href="/register" className="btn btn-link">Ready to connect with someone who gets you? Join now.</a>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button variant="primary" onClick={handleModal4Close}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal5} onHide={handleModal5Close} centered dialogClassName="custom-modal">
        <Modal.Header closeButton className="modal-header-custom">
          <Modal.Title className="modal-title-custom">
            5 Dating App Green Flags You Shouldn’t Ignore — Especially on MarryUp
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <img src={articleImage} alt="Article" className="modal-image" />
          <div className="article-content">
            <p>
              We talk a lot about dating red flags — but what about the signs that you're actually in the right place? If you’re using a dating app that shows these green flags, chances are you’re finally getting closer to real, intentional connection.
            </p>

            <hr />

            <h5>1. The App Screens for Quality</h5>
            <p>
              You’re not swiping through bots or catfish — just real people with substance. MarryUp manually approves new users to keep standards high and fake profiles out.
            </p>

            <h5>2. Profiles Feel Thoughtful, Not Thirsty</h5>
            <p>
              No half-empty bios or blurry mirror pics. Just curated profiles that actually tell you something about the person behind the screen.
            </p>

            <h5>3. It Encourages Intentional Matches</h5>
            <p>
              On MarryUp, you match with people who’ve been handpicked or discovered through intelligent filtering — not just people who liked your latest selfie.
            </p>

            <h5>4. You Feel Safe, Not Spammy</h5>
            <p>
              Real dating should feel secure, not sketchy. MarryUp uses identity checks, manual onboarding, and active moderation to keep things safe and respectful.
            </p>

            <h5>5. It Aligns with Your Lifestyle</h5>
            <p>
              From ambition to aesthetics, a good dating app should reflect your vibe. MarryUp even includes a lifestyle store — so you can share your preferences, values, and aspirations in subtle but powerful ways.
            </p>

            <p className="closing-text">
              <strong>If you're seeing these green flags — you're on the right app.</strong><br />
              <a href="/signup" className="btn btn-link">Join MarryUp and date with clarity.</a>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer-custom">
          <Button variant="primary" onClick={handleModal5Close}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      <Footer />
    </div>
  );
};

export default Blog;
